import '../../css/global/flickity.css';
import '../../css/modules/media_slideshow.css';

import Flickity, { FlickityEvents } from 'flickity';

export class MediaSlideshow {

  private _slideshows: Array<Flickity> = [];
  private _options: Object = {

    autoPlay: 5000,
    pageDots: false,
    prevNextButtons: false,
    wrapAround: true

  }

  private dragMoveEvent: CustomEvent = document.createEvent("CustomEvent");
  private showCursorEvent: CustomEvent = document.createEvent("CustomEvent");
  private hideCursorEvent: CustomEvent = document.createEvent("CustomEvent");
  private changeCursorLabelEvent: CustomEvent;

  constructor() {

    this.showCursorEvent.initEvent("showCursorEvent", false, true);
    this.hideCursorEvent.initEvent("hideCursorEvent", false, true);

    const slideshow_elements: NodeListOf<HTMLElement> = document.querySelectorAll( '.c-media-slideshow' );
    for ( let i: number = 0; i < slideshow_elements.length; i++) this.setupSlideshow( slideshow_elements[ i ] );

  }


  private setupSlideshow( element: HTMLElement ) {

    const slides: HTMLElement = element.querySelector( '.c-media-slideshow__slides' );

    if ( slides ) {

        const slideshow: Flickity = new Flickity( slides, this._options );
        const total: number = parseInt(element.dataset.realCount);
        const counter_element: HTMLElement = element.querySelector( '.c-media-slideshow__counter__current' );
        
        if ( total && counter_element ) slideshow.on( 'select', ( val: number ) => this.handleSlideshowChange( val, total, counter_element ) );
        
        const images: NodeListOf<HTMLImageElement> = element.querySelectorAll( 'img' );
        for ( let i: number = 0; i < images.length; i++ ) {
          
          images[ i ].addEventListener( 'load', () => this.handleImageLoaded( slideshow ) );
          
        }
        
        this._slideshows.push( slideshow );

        slideshow.on( 'dragMove', ( event: Event ) => {

          // @ts-ignore
          this.dragMoveEvent.initCustomEvent("dragMoveEvent", false, true, { x: event.clientX, y: event.clientY } );
          window.dispatchEvent( this.dragMoveEvent );

        } );

        element.addEventListener( 'mouseenter', () => this.handleSlideshowContainerMouseEnter() );
        element.addEventListener( 'mouseleave', () => this.handleSlideshowContainerMouseLeave() );

    }

  }


  private handleSlideshowChange( val: number, total: number, counter_element: HTMLElement ) {

    let corrected_index_val: number = val + 1;
    // - total * 2 because all slides are appended twice when a low number of slides are in the slideshow.
    // Implemented to avoid empty spaces on the sides on wider screens
    corrected_index_val = ( corrected_index_val > total ) ? corrected_index_val - total : corrected_index_val;
    corrected_index_val = ( corrected_index_val > total ) ? corrected_index_val - total : corrected_index_val;
    counter_element.innerText = corrected_index_val.toString();

  }


  private handleImageLoaded( slideshow: Flickity ) {
    
    slideshow.resize();

  }


  private handleSlideshowContainerMouseEnter() {

    this.changeCursorLabelEvent = document.createEvent("CustomEvent");
    this.changeCursorLabelEvent.initCustomEvent("changeCursorLabelEvent", false, true, { label: 'drag' });
    window.dispatchEvent(this.changeCursorLabelEvent);

    window.dispatchEvent(this.showCursorEvent);

  }


  private handleSlideshowContainerMouseLeave() {
    
    window.dispatchEvent(this.hideCursorEvent);
    
  }

}